import { render, staticRenderFns } from "./AttendanceUpdateReport.vue?vue&type=template&id=4b4a805a"
import script from "./AttendanceUpdateReport.vue?vue&type=script&lang=js"
export * from "./AttendanceUpdateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports